import type { MouseEvent } from 'react';

import { BpkInlineLogo, BpkTianxunSkyscannerLogo } from '@skyscanner-internal/bpk-logos';

import handleClickAndTrack from '../utils/handleClickAndTrack';

import type { Logger } from '@web-platform/global-components-types/utils';
import type { TrackingEventFn } from '@web-platform/global-components-utils/tracking';

import STYLES from './Logo.module.scss';

type Props = {
  href?: string;
  hiddenText?: string;
  market: string;
  logger: Logger;
  trackEventFn: TrackingEventFn;
};

const Logo = ({ hiddenText = 'Skyscanner', href = '/', logger, market, trackEventFn }: Props) => {
  const isChinaMarket = market === 'CN';
  const eventTracker = (e: MouseEvent<HTMLAnchorElement>, id: 'identity', eventType: string) => {
    handleClickAndTrack(e, id, eventType, logger, trackEventFn);
  };

  return (
    <a
      href={href}
      className={STYLES.Logo}
      onClick={(e: MouseEvent<HTMLAnchorElement>) => {
        eventTracker(e, 'identity', 'Clicked');
      }}
    >
      {isChinaMarket ? (
        <BpkTianxunSkyscannerLogo className={STYLES.Logo__svgTianxunSkyscanner} aria-hidden />
      ) : (
        <BpkInlineLogo className={STYLES.Logo__svg} aria-hidden />
      )}
      <span className={STYLES.Hidden}>{hiddenText}</span>
    </a>
  );
};

export default Logo;
